import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import React, { useContext, useMemo, useState } from 'react';
import { Box, Copy, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import Context from '../service/Context';
import InfoModal from '../../../utils/components/InfoModal';
import PaymentCalculatorModalAnchor from './PaymentCalculatorModalAnchor';
import themeStyles from '../PaymentDetailsComponent.styles';
import { PaymentFrequency, PaymentMethod, primaryCalculatorId, selectPrimaryCalculatorIsPaymentMethodCash, } from '../../../core/reducers/financialCalculators';
import { useAppSelector } from '../../../core/utils';
import { useLanguage } from '../../../utils/sitecoreContext';
const FinanceWrapper = themeStyles.apply(Box, 'FinanceWrapper');
const FinanceContainer = themeStyles.apply(Box, 'FinanceContainer');
const PaymentAmountContainer = themeStyles.apply(Box, 'PaymentAmountContainer');
const PaymentLabelCopy = themeStyles.apply(Copy, 'PaymentLabelCopy');
const PaymentLabelContent = themeStyles.apply(Box, 'PaymentLabelContent');
const PaymentContentCopy = themeStyles.apply(Copy, 'PaymentContentCopy');
const PaymentFrequencyContainer = themeStyles.apply(Box, 'PaymentFrequencyContainer');
const OnlyFinance = ({ componentType }) => {
    const language = useLanguage();
    const { t } = useTranslation();
    const isPaymentMethodCash = useAppSelector(selectPrimaryCalculatorIsPaymentMethodCash);
    const { paymentLabel, paymentAmount, paymentTooltipParams, terms, apr } = useContext(Context);
    const paymentMethod = t(`Shared.Common.${paymentLabel.method}MethodLabel`);
    const paymentFrequency = t(`Shared.Common.${paymentLabel.frequency}OptionLabel`);
    const paymentFrequencyLabel = paymentLabel.frequency === PaymentFrequency.biweekly ? 'biWeekly' : paymentLabel.frequency;
    const paymentTooltipLabel = t('Shared.Common.paymentTooltipLabel', {
        ...paymentTooltipParams,
        paymentFrequency: t(`Shared.Common.PaymentFrequency.${paymentFrequencyLabel}`),
    });
    const paymentTooltipLabelFinance = t('Shared.Common.paymentTooltipFinanceLabel', {
        ...paymentTooltipParams,
        paymentFrequency: t(`Shared.Common.PaymentFrequency.${paymentFrequencyLabel}`),
    });
    const currentToolTip = useMemo(() => {
        switch (paymentLabel.method) {
            case PaymentMethod.lease:
                return paymentTooltipLabel;
            case PaymentMethod.finance:
                return paymentTooltipLabelFinance;
            default:
                return t('Shared.Common.sellingPriceTooltipLabel');
        }
    }, [paymentLabel.method, paymentTooltipLabel, paymentTooltipLabelFinance, t]);
    const [showInfoModal, setShowInfoModal] = useState(false);
    return (React.createElement(FinanceWrapper, null,
        React.createElement(PaymentAmountContainer, null,
            React.createElement(PaymentLabelContent, { "data-testid": "cy-payment-frequency-label" },
                React.createElement(PaymentLabelCopy, { size: "extraSmall", "data-testid": "cy-payment-frequency-label" }, paymentMethod),
                React.createElement(Optional, { when: !isPaymentMethodCash },
                    React.createElement(InfoModal, { showModal: showInfoModal, setShowModal: setShowInfoModal, content: currentToolTip, isDark: false, "data-testid": "cy-payment-tooltip", display: "inline-block", ml: "0" })),
                React.createElement(PaymentCalculatorModalAnchor, { componentType: componentType, calculatorId: primaryCalculatorId }))),
        React.createElement(Optional, { when: !isPaymentMethodCash && paymentAmount },
            React.createElement(FinanceContainer, null,
                React.createElement(PaymentFrequencyContainer, null,
                    React.createElement(PaymentContentCopy, { size: "payment", "data-testid": "cy-payment-frequency-value" }, formatPrice(paymentAmount, language, 2)),
                    React.createElement(PaymentLabelCopy, { fontWeight: "bold", size: "payment", "data-testid": "cy-payment-frequency-label" },
                        "/ ",
                        paymentFrequency)),
                React.createElement(PaymentContentCopy, { textAlign: "left", size: "payment", "data-testid": "cy-payment-term-rate-value" }, t('Pages.Bap.termAndRateDynamicLabel', { term: terms, apr }))))));
};
export default OnlyFinance;
